module.exports = __webpack_public_path__ + "notifications.3ee8d8ae56ca0560925cb6d6fea8b1e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/notifications.svg
// module id = 342
// module chunks = 0